import { mapGetters } from 'vuex';
import geoMapper from '../../../common/store/mapper/_geoMapper.js';
import { formatFriendlyPrice } from '../../../common/filters/index.js';

function convertGeoInfo(data, rentals) {
    const geoInfo = geoMapper(data, rentals);
    geoInfo.medianListPrice = !rentals && data.medianListPrice > 0 ? formatFriendlyPrice(data.medianListPrice) : null;
    geoInfo.distance = data.distance;
    return geoInfo;
}

export default {
    name: 'searchSeoLink',
    root: true,
    props: {
        rentals: {
            type: Boolean,
            default: false,
        },
        cities: {
            type: Array,
            default() {
                return [];
            },
        },
        zipcodes: {
            type: Array,
            default() {
                return [];
            },
        },
        neighborhoods: {
            type: Array,
            default() {
                return [];
            },
        },
        counties: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('msp', ['geo']),
        linkPrefix() {
            return this.rentals ? this.molang('search.common.homesForRentIn') : this.molang('search.common.homesForSaleIn');
        },
        cityLinks() {
            return this.generateLinks(this.cities);
        },
        zipcodeLinks() {
            return this.generateLinks(this.zipcodes);
        },
        countyLinks() {
            return this.generateLinks(this.counties);
        },
        neighborhoodLinks() {
            return this.generateLinks(this.neighborhoods);
        },
        sectionVisibility() {
            return (
                (this.cityLinks && this.cityLinks.length) ||
                (this.zipcodeLinks && this.zipcodeLinks.length) ||
                (this.countyLinks && this.countyLinks.length) ||
                (this.neighborhoodLinks && this.neighborhoodLinks.length)
            );
        },
    },
    methods: {
        generateLinks(dataArray) {
            let links = dataArray.map( item => convertGeoInfo(item, this.rentals));
            return links;
        }
    }
};
